export default __webpack_public_path__ + "static/media/pickshareMenu-small.5aa02f83.mp4";